/**
 * Profile ID strings and handle identifiers decoupled from solver modules.
 * This file contains ONLY literal strings and pure types to avoid dragging
 * heavy simulation solvers into the startup bundle.
 */

export const EO_CANVAS_REAL_PROPERTY_PRESSURE_SERIES_EXECUTION_PROFILE =
  'real-property-pressure-series-v3' as const;

export const EO_CANVAS_FIXED_SPLIT_RECOMBINE_EXECUTION_PROFILE =
  'fixed-split-recombine-v3' as const;

export const EO_GRAPH_V3_GENERAL_REAL_WATER_HEATER_V6_SOLVER_PROFILE =
  'general-real-water-pipe-junction-network-v6' as const;

export const EO_GRAPH_V3_SHAFT_COUPLED_RANKINE_SOLVER_PROFILE =
  'eo-real-fluid-water-rankine-cycle-shaft-coupled-v3' as const;

export const EO_GRAPH_V3_SHAFT_COUPLED_DRY_COOLED_RANKINE_ACC_SOLVER_PROFILE =
  'eo-real-fluid-water-dry-cooled-rankine-acc-shaft-coupled-v3' as const;

export const EO_CANVAS_SHAFT_COUPLED_RANKINE_TURBINE_SOURCE_HANDLE =
  'shaft-source' as const;
export const EO_CANVAS_SHAFT_COUPLED_RANKINE_SHAFT_TURBINE_HANDLE =
  'turbine-source' as const;
export const EO_CANVAS_SHAFT_COUPLED_RANKINE_SHAFT_PUMP_HANDLE =
  'pump-load' as const;
export const EO_CANVAS_SHAFT_COUPLED_RANKINE_PUMP_LOAD_HANDLE =
  'shaft-load' as const;
